// Custom inline SVG icons for medieval flavor.
// Drawn at 64x64 grid for richer detail.

const I = ({ size = 24, className = "", children, viewBox = "0 0 64 64", strokeWidth = 2 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={viewBox}
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    {children}
  </svg>
);

// === FistBumpIcon ===========================================================
// Two large fists meeting in the centre. Thumbs are tucked over the top of
// the curled fingers with a clearly raised thumb-knuckle that protrudes
// above the knuckle line.
export const FistBumpIcon = (p) => (
  <I {...p}>
    {/* --- Left fist --- */}
    {/* Forearm cuff */}
    <path d="M2 24h6v16H2z" fill="currentColor" fillOpacity="0.18" />
    <path d="M2 24h6v16H2z" />
    <path d="M2 27h6M2 37h6" strokeWidth="1.2" strokeOpacity="0.6" />
    {/* Hand body */}
    <path
      d="M8 22c0-2 1.6-3.5 3.6-3.5h12.4c2.4 0 4 1.8 4 4v19c0 2.2-1.6 4-4 4H11.6c-2 0-3.6-1.5-3.6-3.5z"
      fill="currentColor" fillOpacity="0.22"
    />
    <path d="M8 22c0-2 1.6-3.5 3.6-3.5h12.4c2.4 0 4 1.8 4 4v19c0 2.2-1.6 4-4 4H11.6c-2 0-3.6-1.5-3.6-3.5z" />
    {/* Knuckle ridges (4) */}
    <path d="M28 22.5c1 .5 1.6 1.5 1.6 2.5v3c0 1-.6 2-1.6 2.5" />
    <path d="M28 30c1 .5 1.6 1.5 1.6 2.5v3c0 1-.6 2-1.6 2.5" />
    <path d="M28 37.5c1 .5 1.6 1.5 1.6 2.5v3c0 1-.6 2-1.6 2.5" />
    <path d="M28 45c1 .5 1.6 1.5 1.6 2c0 1-.6 2-1.6 2.5" />
    {/* THUMB — wrapped over knuckles, with a clearly protruding thumb-knuckle bump
        (the rounded peak above the line of fingers). */}
    <path
      d="M14 14.5c-1.5 0-3 .8-3.5 2.2L9.8 19c-.8 2 .2 4.2 2.2 4.6l1.5.4c1 .2 2 1 2.2 2l.3 1.5c.3 1.4 1.6 2.5 3 2.5h2"
      fill="currentColor" fillOpacity="0.40"
    />
    <path d="M14 14.5c-1.5 0-3 .8-3.5 2.2L9.8 19c-.8 2 .2 4.2 2.2 4.6l1.5.4c1 .2 2 1 2.2 2l.3 1.5c.3 1.4 1.6 2.5 3 2.5h2" />
    {/* Thumb-knuckle bump highlight */}
    <path d="M11 18.5c.6-1.2 2.2-1.4 3 0" strokeWidth="1.4" />
    {/* Thumbnail */}
    <path d="M11.5 16.6c.6-.4 1.4-.4 2 0" strokeWidth="1.1" strokeOpacity="0.7" />
    {/* Knuckle creases */}
    <path d="M16 30c1 1 4 1 5 0M16 38c1 1 4 1 5 0" strokeWidth="1.1" strokeOpacity="0.5" />

    {/* --- Right fist (mirror) --- */}
    <path d="M62 24h-6v16h6z" fill="currentColor" fillOpacity="0.18" />
    <path d="M62 24h-6v16h6z" />
    <path d="M62 27h-6M62 37h-6" strokeWidth="1.2" strokeOpacity="0.6" />
    <path
      d="M56 22c0-2-1.6-3.5-3.6-3.5H40c-2.4 0-4 1.8-4 4v19c0 2.2 1.6 4 4 4h12.4c2 0 3.6-1.5 3.6-3.5z"
      fill="currentColor" fillOpacity="0.22"
    />
    <path d="M56 22c0-2-1.6-3.5-3.6-3.5H40c-2.4 0-4 1.8-4 4v19c0 2.2 1.6 4 4 4h12.4c2 0 3.6-1.5 3.6-3.5z" />
    <path d="M36 22.5c-1 .5-1.6 1.5-1.6 2.5v3c0 1 .6 2 1.6 2.5" />
    <path d="M36 30c-1 .5-1.6 1.5-1.6 2.5v3c0 1 .6 2 1.6 2.5" />
    <path d="M36 37.5c-1 .5-1.6 1.5-1.6 2.5v3c0 1 .6 2 1.6 2.5" />
    <path d="M36 45c-1 .5-1.6 1.5-1.6 2c0 1 .6 2 1.6 2.5" />
    {/* Mirror thumb */}
    <path
      d="M50 14.5c1.5 0 3 .8 3.5 2.2l.7 2.3c.8 2-.2 4.2-2.2 4.6l-1.5.4c-1 .2-2 1-2.2 2l-.3 1.5c-.3 1.4-1.6 2.5-3 2.5h-2"
      fill="currentColor" fillOpacity="0.40"
    />
    <path d="M50 14.5c1.5 0 3 .8 3.5 2.2l.7 2.3c.8 2-.2 4.2-2.2 4.6l-1.5.4c-1 .2-2 1-2.2 2l-.3 1.5c-.3 1.4-1.6 2.5-3 2.5h-2" />
    <path d="M53 18.5c-.6-1.2-2.2-1.4-3 0" strokeWidth="1.4" />
    <path d="M52.5 16.6c-.6-.4-1.4-.4-2 0" strokeWidth="1.1" strokeOpacity="0.7" />
    <path d="M43 30c1 1 4 1 5 0M43 38c1 1 4 1 5 0" strokeWidth="1.1" strokeOpacity="0.5" />

    {/* --- Impact sparks in the meeting gap --- */}
    <path d="M32 12v4M32 48v4M28 16l-3-3M36 16l3-3M28 48l-3 3M36 48l3 3" strokeWidth="1.5" />
  </I>
);

// === SquireIcon ============================================================
// Young squire — bare-headed, ENLARGED HEAD filling the frame, with a short,
// neat haircut, a trimmed moustache and short beard, and a slightly surly
// (downward-slanted brow, set jaw) expression. Plain leather collar/jerkin
// at the neck, no chainmail coif, no shawl.
export const SquireIcon = (p) => (
  <I {...p} strokeWidth={1.5}>
    {/* Leather jerkin collar — minimal, just a strip beneath the chin so
        the head dominates the icon. */}
    <path d="M16 56 C 22 52, 42 52, 48 56 L 48 62 L 16 62 Z"
          fill="currentColor" fillOpacity="0.20" />
    <path d="M16 56 C 22 52, 42 52, 48 56" />
    <path d="M27 53 v 4 M37 53 v 4" strokeOpacity="0.55" />

    {/* HEAD — enlarged oval filling most of the frame */}
    <path
      d="M14 30
         C 14 18, 22 8, 32 8
         C 42 8, 50 18, 50 30
         L 50 42
         C 50 50, 44 56, 32 56
         C 20 56, 14 50, 14 42 Z"
      fill="currentColor" fillOpacity="0.10"
    />
    <path
      d="M14 30
         C 14 18, 22 8, 32 8
         C 42 8, 50 18, 50 30
         L 50 42
         C 50 50, 44 56, 32 56
         C 20 56, 14 50, 14 42 Z"
    />

    {/* SHORT NEAT HAIRCUT — clean horizontal sweep across the forehead,
        only the top of the head, short on the sides. No tufts, no shawl. */}
    <path
      d="M16 22
         C 18 14, 24 10, 32 10
         C 40 10, 46 14, 48 22
         L 47 24
         C 44 20, 38 18, 32 18
         C 26 18, 20 20, 17 24 Z"
      fill="currentColor" fillOpacity="0.85"
    />
    {/* Sideburn taper — short and clean */}
    <path d="M16 22 L 16 28 M48 22 L 48 28" strokeOpacity="0.6" />

    {/* Ears — small, peeking past the hair */}
    <path d="M15 30 c -1.5 .3 -2.5 1.5 -2.5 3 s 1 2.6 2.5 3"
          strokeOpacity="0.75" />
    <path d="M49 30 c 1.5 .3 2.5 1.5 2.5 3 s -1 2.6 -2.5 3"
          strokeOpacity="0.75" />

    {/* Surly BROW — slanted downward toward the centre (frown) */}
    <path d="M22 30 L 28 28" strokeWidth="1.6" />
    <path d="M42 30 L 36 28" strokeWidth="1.6" />

    {/* EYES — narrowed, slightly shadowed (surly look) */}
    <path d="M24 33 c 1 -1, 4 -1, 5 0" strokeWidth="1.4" />
    <path d="M35 33 c 1 -1, 4 -1, 5 0" strokeWidth="1.4" />
    <ellipse cx="26.5" cy="34" rx="1" ry="0.9" fill="currentColor" />
    <ellipse cx="37.5" cy="34" rx="1" ry="0.9" fill="currentColor" />

    {/* NOSE — straight, slight nostril hint */}
    <path d="M32 35 v 6 c 0 1, -.6 1.6, -1.4 1.6" strokeWidth="1.3" />
    <path d="M32 42 c 1 .6, 2 .6, 3 0" strokeWidth="1" strokeOpacity="0.55" />

    {/* MOUSTACHE — short, drooping slightly at the corners (surly) */}
    <path d="M26 46 c 2 -.5, 4 -.5, 6 0 c 2 -.5, 4 -.5, 6 0"
          strokeWidth="1.5" />
    {/* Shadow under moustache (top lip) */}
    <path d="M28 47.5 c 2 .4, 6 .4, 8 0" strokeOpacity="0.5" />

    {/* MOUTH — set, slightly down-turned at the corners (surly) */}
    <path d="M28 50 c 2 .8, 6 .8, 8 0" strokeWidth="1.4" />
    <path d="M28 50 l -1 -1 M36 50 l 1 -1" strokeWidth="1" strokeOpacity="0.6" />

    {/* SHORT BEARD — close-trimmed along the jawline + chin */}
    <path
      d="M22 49
         C 23 53, 26 56, 32 56
         C 38 56, 41 53, 42 49
         C 41 51, 38 52, 32 52
         C 26 52, 23 51, 22 49 Z"
      fill="currentColor" fillOpacity="0.6"
    />
    {/* Beard texture — short stipple strokes */}
    <path d="M24 51 l .5 1 M28 53 l .3 1 M32 54 v 1 M36 53 l -.3 1 M40 51 l -.5 1"
          strokeWidth="1" strokeOpacity="0.7" />
  </I>
);

// === KnightIcon ============================================================
// Raised-visor bascinet with a POINTY CHIN tapering to a point at the
// bottom, plus a MUCH LONGER plume on top. Outline only — no fill shading.
export const KnightIcon = (p) => (
  <I {...p} strokeWidth={1.5}>
    {/* === LONG plume staff + tufts (extends well above the helm) */}
    <path d="M32 18 L 32 -8" strokeWidth="1.8" />
    <path d="M32 -8 C 26 -6, 23 0, 22 8" />
    <path d="M32 -8 C 38 -6, 41 0, 42 8" />
    <path d="M32 -4 C 27 -1, 24 5, 23.5 12" strokeOpacity="0.7" />
    <path d="M32 -4 C 37 -1, 40 5, 40.5 12" strokeOpacity="0.7" />
    <path d="M32 0 C 28 3, 26 8, 26 14" strokeOpacity="0.55" />
    <path d="M32 0 C 36 3, 38 8, 38 14" strokeOpacity="0.55" />
    <path d="M32 4 C 30 7, 29 11, 29 16" strokeOpacity="0.4" />
    <path d="M32 4 C 34 7, 35 11, 35 16" strokeOpacity="0.4" />

    {/* === MAIN HELM SHELL with POINTY CHIN === */}
    <path d="M14 26 C 14 17, 22 8, 32 8 C 42 8, 50 17, 50 26 L 50 38 L 32 60 L 14 38 Z" />
    <circle cx="22" cy="18" r="1.1" />
    <circle cx="42" cy="18" r="1.1" />

    {/* === RAISED VISOR === */}
    <path d="M14 26 C 16 18, 24 14, 32 14 C 40 14, 48 18, 50 26" />
    <path d="M16 28 C 20 22, 26 19, 32 19 C 38 19, 44 22, 48 28" />
    <circle cx="14" cy="26" r="1.5" />
    <circle cx="50" cy="26" r="1.5" />
    <path d="M22 22 C 27 19, 37 19, 42 22" strokeOpacity="0.55" />

    {/* === EYE OPENING (outlined) === */}
    <path d="M16 28 C 22 30, 42 30, 48 28 L 48 33 C 42 35, 22 35, 16 33 Z" />
    <ellipse cx="26" cy="31.5" rx="2" ry="1.3" fill="#FFE9A3" />
    <ellipse cx="38" cy="31.5" rx="2" ry="1.3" fill="#FFE9A3" />
    <ellipse cx="26" cy="31.7" rx="0.95" ry="1" />
    <ellipse cx="38" cy="31.7" rx="0.95" ry="1" />

    {/* Centre seam down to pointy chin */}
    <path d="M32 35 L 32 60" strokeOpacity="0.55" />
    <circle cx="22" cy="42" r="0.9" />
    <circle cx="42" cy="42" r="0.9" />
    <path d="M27 47 h 10" strokeOpacity="0.55" />
    <path d="M27 49 h 10" strokeOpacity="0.55" />
  </I>
);

// === ChampionIcon ==========================================================
// Closed great-helm with TWO TALL UPRIGHT PLUMES standing up from the
// crown (one slightly left of centre, one slightly right), fleur-de-lis
// crest, medallions, eye slit, and POINTY CHIN. Outline only.
export const ChampionIcon = (p) => (
  <I {...p} strokeWidth={1.5}>
    {/* === Tall upright LEFT plume — stands straight up from the crown === */}
    <path d="M26 10 L 24 -16" />
    <path d="M26 10 C 22 -2, 20 -10, 20 -16" strokeOpacity="0.7" />
    <path d="M26 10 C 26 0, 26 -8, 26 -16" strokeOpacity="0.55" />
    <path d="M22 -10 L 22 -16" strokeOpacity="0.5" />

    {/* === Tall upright RIGHT plume === */}
    <path d="M38 10 L 40 -16" />
    <path d="M38 10 C 42 -2, 44 -10, 44 -16" strokeOpacity="0.7" />
    <path d="M38 10 C 38 0, 38 -8, 38 -16" strokeOpacity="0.55" />
    <path d="M42 -10 L 42 -16" strokeOpacity="0.5" />

    {/* === Fleur-de-lis crest === */}
    <path d="M32 2 C 30 4, 30 6, 32 8 C 34 6, 34 4, 32 2 Z" />
    <path d="M32 4 C 28 4, 26 6, 27 9 C 29 8, 31 7, 32 6" />
    <path d="M32 4 C 36 4, 38 6, 37 9 C 35 8, 33 7, 32 6" />
    <path d="M28 8 L 36 8 L 35 10 L 29 10 Z" />

    {/* === HELM SILHOUETTE with POINTY CHIN === */}
    <path d="M32 10 C 18 10, 10 22, 10 30 C 10 36, 11 40, 12 44 C 13 50, 14 54, 16 58 L 32 62 L 48 58 C 50 54, 51 50, 52 44 C 53 40, 54 36, 54 30 C 54 22, 46 10, 32 10 Z" />

    {/* Dome scrollwork */}
    <path d="M14 22 C 20 14, 44 14, 50 22" strokeOpacity="0.6" />
    <path d="M16 18 C 22 12, 42 12, 48 18" strokeOpacity="0.45" />
    <circle cx="22" cy="16" r="0.7" />
    <circle cx="32" cy="14" r="0.8" />
    <circle cx="42" cy="16" r="0.7" />

    {/* Reinforcement band */}
    <path d="M11 30 C 18 27, 46 27, 53 30 L 53 35 C 46 38, 18 38, 11 35 Z" />
    {[14, 22, 32, 42, 50].map((cx, i) => (
      <g key={`med-${i}`}>
        <circle cx={cx} cy={32.5} r="1.6" />
        <circle cx={cx} cy={32.5} r="0.6" fill="#F8E08A" />
      </g>
    ))}

    {/* Eye slit (outlined) */}
    <path d="M16 32 C 22 30.5, 42 30.5, 48 32 C 42 33.5, 22 33.5, 16 32 Z" />

    {/* Centre seam down to pointy chin */}
    <path d="M32 38 L 32 62" strokeOpacity="0.55" />
    <path d="M28 44 L 36 44" strokeOpacity="0.6" />
    <path d="M30 47 L 34 47" strokeOpacity="0.55" />
  </I>
);

// === BigTableIcon ==========================================================
// One-point perspective banquet table with VERY THICK legs (no grey wash)
// and an OPAQUE parchment-filled table top that naturally occludes the
// back-legs as well as the inner edges of the flanking benches. The
// benches sit alongside the table's left and right sides and their long
// edges share the table's vanishing point. NO mugs, NO bench legs.
export const BigTableIcon = (p) => (
  <I {...p}>
    {/* === BACK LEGS (drawn FIRST so the opaque table top occludes them) === */}
    <path d="M21 26 L 26 26 L 26 56 L 21 56 Z" fill="#F1E3C0" />
    <path d="M21 26 L 26 26 L 26 56 L 21 56 Z" />
    <path d="M38 26 L 43 26 L 43 56 L 38 56 Z" fill="#F1E3C0" />
    <path d="M38 26 L 43 26 L 43 56 L 38 56 Z" />

    {/* === LEFT BENCH — wide parallelogram alongside the table's left edge.
         Inner edge intentionally extended a bit INTO the table footprint so
         the opaque table top can occlude it naturally. === */}
    <path d="M24 24 L 14 24 L -10 42 L 8 42 Z" fill="#F1E3C0" />
    <path d="M24 24 L 14 24 L -10 42 L 8 42 Z" />
    {/* Bench seat front-thickness strip */}
    <path d="M-10 42 L 8 42 L 8 46 L -10 46 Z" fill="#F1E3C0" />
    <path d="M-10 42 L 8 42 L 8 46 L -10 46 Z" />

    {/* === RIGHT BENCH === mirror, with the same inner-edge overlap */}
    <path d="M40 24 L 50 24 L 74 42 L 56 42 Z" fill="#F1E3C0" />
    <path d="M40 24 L 50 24 L 74 42 L 56 42 Z" />
    <path d="M56 42 L 74 42 L 74 46 L 56 46 Z" fill="#F1E3C0" />
    <path d="M56 42 L 74 42 L 74 46 L 56 46 Z" />

    {/* === TABLE TOP — OPAQUE parchment fill, occludes back legs and
         the inner edges of both benches that overlap into the trapezoid === */}
    <path d="M22 24 L 42 24 L 58 42 L 6 42 Z" fill="#F1E3C0" />
    <path d="M22 24 L 42 24 L 58 42 L 6 42 Z" />
    {/* Plank seams converging toward the same vanishing point */}
    <path d="M28 24 L 21 42" strokeOpacity="0.55" />
    <path d="M32 24 L 32 42" strokeOpacity="0.55" />
    <path d="M36 24 L 43 42" strokeOpacity="0.55" />
    {/* Front edge thickness */}
    <path d="M6 42 L 7 44 L 57 44 L 58 42" />

    {/* === FRONT LEGS — drawn AFTER table; opaque parchment fill, NO grey wash === */}
    <path d="M4 44 L 12 44 L 12 60 L 4 60 Z" fill="#F1E3C0" />
    <path d="M4 44 L 12 44 L 12 60 L 4 60 Z" />
    <path d="M52 44 L 60 44 L 60 60 L 52 60 Z" fill="#F1E3C0" />
    <path d="M52 44 L 60 44 L 60 60 L 52 60 Z" />

    {/* === FOUR MUGS OF MEAD — placed asymmetrically across the table top
         (different perspective sizes, off-axis, not mirror-symmetric). === */}
    {/* Mug 1 — back-left, small (perspective) */}
    <path d="M21 27 L 24 27 L 24 32 L 21 32 Z" />
    <path d="M20.6 26.6 C 21.5 26.2, 23.4 26.2, 24.4 26.6 L 24 27.4 L 21 27.4 Z" fill="#F8E08A" />
    <path d="M24 28 C 25 28, 25 30, 24 30" />
    {/* Mug 2 — back-right area, slightly larger and lower (asymmetric) */}
    <path d="M37 29 L 40.5 29 L 40.5 34.5 L 37 34.5 Z" />
    <path d="M36.5 28.5 C 37.5 28.1, 40 28.1, 41 28.5 L 40.5 29.4 L 37 29.4 Z" fill="#F8E08A" />
    <path d="M40.5 30 C 41.7 30, 41.7 32.3, 40.5 32.3" />
    {/* Mug 3 — front, off to the LEFT (not mirroring Mug 4) */}
    <path d="M13 35 L 17 35 L 17 41 L 13 41 Z" />
    <path d="M12.4 34.2 C 14, 33.6, 17, 33.6, 17.6, 34.2 L 17 35.2 L 13 35.2 Z" fill="#F8E08A" />
    <path d="M17 36 C 18.6 36, 18.6 39.4, 17 39.4" />
    {/* Mug 4 — front, pushed further to the RIGHT and at a different y (asymmetric) */}
    <path d="M44 36.5 L 48 36.5 L 48 42 L 44 42 Z" />
    <path d="M43.4 35.7 C 45, 35.1, 48, 35.1, 48.6, 35.7 L 48 36.7 L 44 36.7 Z" fill="#F8E08A" />
    <path d="M48 37.4 C 49.6 37.4, 49.6 40.6, 48 40.6" />
  </I>
);

// === HostSmallTableIcon ====================================================
// Round table + tall taper-candle. Two perspective parallelogram benches
// MOVED CLOSER TO THE VIEWER (lower y) and with SHORTER LEGS, vanishing
// point still matched to the table's perspective.
export const HostSmallTableIcon = (p) => (
  <I {...p}>
    {/* Candle flame */}
    <path d="M32 6 C 33 9, 33 11, 32 13 C 31 11, 31 9, 32 6 Z" />
    <path d="M32 8 C 32.5 10, 32.5 11.5, 32 12.5 C 31.5 11.5, 31.5 10, 32 8 Z" fill="#F8E08A" />
    {/* Candle taper */}
    <path d="M30 13 h 4 v 12 h -4 z" />
    <path d="M30 23 c 0 1.5, 1 2, 2 2 s 2 -.5, 2 -2" strokeOpacity="0.6" />
    {/* Candle dish */}
    <ellipse cx="32" cy="26" rx="6" ry="1.3" />

    {/* === LEFT BENCH back-end legs (drawn BEFORE the seat). VERY SHORT —
         legs only extend ~3u below the seat for a stubby look. === */}
    <path d="M8 36 L 11 36 L 11 51 L 8 51 Z" fill="#F1E3C0" />
    <path d="M8 36 L 11 36 L 11 51 L 8 51 Z" />
    <path d="M13 36 L 16 36 L 16 51 L 13 51 Z" fill="#F1E3C0" />
    <path d="M13 36 L 16 36 L 16 51 L 13 51 Z" />
    {/* === LEFT BENCH seat — opaque parchment fill so legs naturally occlude */}
    <path d="M16 36 L 8 36 L -10 48 L 4 48 Z" fill="#F1E3C0" />
    <path d="M16 36 L 8 36 L -10 48 L 4 48 Z" />
    <path d="M6 37 L -8 47" strokeOpacity="0.45" />

    {/* === RIGHT BENCH back-end legs (mirror, very short) === */}
    <path d="M48 36 L 51 36 L 51 51 L 48 51 Z" fill="#F1E3C0" />
    <path d="M48 36 L 51 36 L 51 51 L 48 51 Z" />
    <path d="M53 36 L 56 36 L 56 51 L 53 51 Z" fill="#F1E3C0" />
    <path d="M53 36 L 56 36 L 56 51 L 53 51 Z" />
    {/* === RIGHT BENCH seat (mirror, opaque) === */}
    <path d="M48 36 L 56 36 L 74 48 L 60 48 Z" fill="#F1E3C0" />
    <path d="M48 36 L 56 36 L 74 48 L 60 48 Z" />
    <path d="M58 37 L 72 47" strokeOpacity="0.45" />

    {/* Round table top — OPAQUE parchment fill so it occludes the inner
        ends of both benches that overlap into the table footprint. */}
    <ellipse cx="32" cy="34" rx="20" ry="5" fill="#F1E3C0" />
    <ellipse cx="32" cy="34" rx="20" ry="5" />
    <ellipse cx="32" cy="34" rx="14" ry="3.2" strokeOpacity="0.45" fill="none" />

    {/* Pedestal */}
    <path d="M28 38 v 12 c 0 1, 1 2, 4 2 s 4 -1, 4 -2 v -12 z" fill="#F1E3C0" />
    <path d="M28 38 v 12 c 0 1, 1 2, 4 2 s 4 -1, 4 -2 v -12 z" />
    <ellipse cx="32" cy="54" rx="7" ry="2" fill="#F1E3C0" />
    <ellipse cx="32" cy="54" rx="7" ry="2" />
  </I>
);

// === JoinSmallTableIcon ====================================================
// Symmetrical human figure SITTING BEHIND the table with two mugs of mead.
// • Elliptical head (taller than wide) on a symmetrical body
// • Thick equal-length arms reaching from each shoulder to a hand on the
//   table top
// • The opaque parchment-filled table OCCLUDES the figure from the belly down
export const JoinSmallTableIcon = (p) => (
  <I {...p}>
    {/* === FIGURE (drawn FIRST so the table can occlude its lower half) === */}
    {/* Elliptical head — taller than wide */}
    <ellipse cx="32" cy="12" rx="5" ry="7" fill="#F1E3C0" />
    <ellipse cx="32" cy="12" rx="5" ry="7" />
    {/* Symmetrical torso/yoke — shoulders at y=25, sides go down past the
        table top so the table covers them naturally */}
    <path d="M22 25 C 24 22, 28 21, 32 21 C 36 21, 40 22, 42 25" fill="#F1E3C0" />
    <path d="M22 25 C 24 22, 28 21, 32 21 C 36 21, 40 22, 42 25" />
    <path d="M22 25 L 22 50" strokeWidth="3" />
    <path d="M42 25 L 42 50" strokeWidth="3" />
    <path d="M22 25 L 42 25" />
    {/* Thick arms of EQUAL LENGTH — each from shoulder to hand on the
        table top edge. Hand-touching points are mirrored about x=32 so the
        Pythagorean lengths are identical. */}
    <path d="M22 25 L 18 41" strokeWidth="4" />
    <path d="M42 25 L 46 41" strokeWidth="4" />

    {/* === TABLE TOP — opaque parchment slab, drawn AFTER the figure so it
         OCCLUDES everything from belly down (y>=42) === */}
    <path d="M-2 42 L 66 42 L 66 50 L -2 50 Z" fill="#F1E3C0" />
    <path d="M-2 42 L 66 42 L 66 50 L -2 50 Z" />
    <path d="M-2 46 L 66 46" strokeOpacity="0.55" />

    {/* === Hands ON the table edge (drawn AFTER the table so they sit on
         top of the table front lip — the figure's arms run behind/under the
         hand position because the table covers the lower forearm) === */}
    <ellipse cx="18" cy="41" rx="2.4" ry="1.6" fill="#F1E3C0" />
    <ellipse cx="18" cy="41" rx="2.4" ry="1.6" />
    <ellipse cx="46" cy="41" rx="2.4" ry="1.6" fill="#F1E3C0" />
    <ellipse cx="46" cy="41" rx="2.4" ry="1.6" />

    {/* === TWO MUGS OF MEAD on the table top === */}
    <path d="M24 36 L 28 36 L 28 42 L 24 42 Z" />
    <path d="M23.5 35 C 25 34.4, 28 34.4, 28.5 35 L 28 36 L 24 36 Z" fill="#F8E08A" />
    <path d="M28 37 C 30 37, 30 41, 28 41" />
    <path d="M36 36 L 40 36 L 40 42 L 36 42 Z" />
    <path d="M35.5 35 C 37 34.4, 40 34.4, 40.5 35 L 40 36 L 36 36 Z" fill="#F8E08A" />
    <path d="M40 37 C 42 37, 42 41, 40 41" />
  </I>
);

// === DaggerInWoodIcon ======================================================
// A dagger sunk vertically into a wooden plank.
export const DaggerInWoodIcon = (p) => (
  <I {...p}>
    {/* Dagger pommel */}
    <circle cx="32" cy="6" r="3" fill="currentColor" fillOpacity="0.45" />
    <circle cx="32" cy="6" r="3" />
    {/* Grip */}
    <path d="M30 9h4v8h-4z" fill="currentColor" fillOpacity="0.55" />
    <path d="M30 9h4v8h-4z" />
    <path d="M30 11h4M30 13h4M30 15h4" strokeWidth="1.1" strokeOpacity="0.6" />
    {/* Cross-guard */}
    <path d="M22 17h20v3H22z" fill="currentColor" fillOpacity="0.5" />
    <path d="M22 17h20v3H22z" />
    <circle cx="22" cy="18.5" r="1" fill="currentColor" />
    <circle cx="42" cy="18.5" r="1" fill="currentColor" />
    {/* Blade */}
    <path d="M32 20l3 2v18l-3 4-3-4V22z" fill="currentColor" fillOpacity="0.25" />
    <path d="M32 20l3 2v18l-3 4-3-4V22z" />
    <path d="M32 22v22" strokeWidth="1.1" strokeOpacity="0.65" />
    {/* Wooden plank */}
    <path d="M6 46h52v12H6z" fill="currentColor" fillOpacity="0.30" />
    <path d="M6 46h52v12H6z" />
    <path d="M10 50c12-2 20 0 30 0c5 0 10-1 14-1" strokeWidth="1.1" strokeOpacity="0.55" />
    <path d="M8 54c10 1 22-1 32 0c4 .5 9 0 14-1" strokeWidth="1.1" strokeOpacity="0.55" />
    <circle cx="20" cy="51" r="1.4" fill="currentColor" fillOpacity="0.45" />
    <circle cx="46" cy="55" r="1.6" fill="currentColor" fillOpacity="0.45" />
    <path d="M27 46l-1 2M37 46l1 2M30 46l.5 2M34 46l-.5 2" strokeWidth="1.2" />
  </I>
);
